import {connect} from "react-redux";
import {validateChangeBags} from "../../actions/index";
import {MAIN_MODAL_HIDE} from "../../actions/modal";

import ChangeNumberOfBagsModalContent from "./ChangeNumberOfBagsModalContent";


export const ChangeNumberOfBagsModal = connect(
  (state) => ({
    "modal" : state.m.modal,
    "pseudoZones": state.m.pseudoZones,
  }),
  (dispatch) => {
    return {
      "hide": () => {
        dispatch({"type": MAIN_MODAL_HIDE});
      },
      "validate": (values) => {
        let extraPlacePzBags = [];
        for (let k in values) {
          if (k.startsWith('pz_')) {
            let x = k.split('_');
            extraPlacePzBags.push({
              pseudo_zone_id: parseInt(x[5], 10),
              number_of_bags_isotherm: values[k]
            });
          }
        }

        dispatch({'type': MAIN_MODAL_HIDE});

        // Compute number of bags from dry and iso bags
        let number_of_bags = values.number_of_bags_iso + values.number_of_bags_dry;
        dispatch(validateChangeBags(
          values.orderId,
          number_of_bags,
          values.number_of_bags_iso,
          extraPlacePzBags
        ));
      }
    };
  }
)(ChangeNumberOfBagsModalContent);
